module.exports = __webpack_public_path__ + "img/PrintStage.a086741d.svg";